import { render, staticRenderFns } from "./PlaygroundsCard.vue?vue&type=template&id=12e8c4c6&scoped=true"
import script from "./PlaygroundsCard.vue?vue&type=script&lang=js"
export * from "./PlaygroundsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e8c4c6",
  null
  
)

export default component.exports